/** @jsx jsx */
import { GatsbyImage } from 'gatsby-plugin-image'
import { jsx } from 'theme-ui'

const InstagramPostImage = ({ image }) => (
  <GatsbyImage
    image={image.gatsbyImageData}
    alt={image.description}
    sx={{ height: 'auto', width: '100%' }}
  />
)

const InstagramPost = ({ post }) => {
  const { postImage, postUrl } = post

  if (postUrl) {
    return (
      <a
        href={postUrl}
        target="_blank"
        rel="noreferrer"
        title="Maker Wine on Instagram (opens in a new window)"
      >
        <InstagramPostImage image={postImage} />
      </a>
    )
  }

  return <InstagramPostImage image={postImage} />
}

export default InstagramPost
